import { type OaDealStatus, oaDealStatus } from '@openx/types/deal.ts';

export const canArchiveDeal = (status: OaDealStatus): boolean => {
  const disabledStatuses = [
    oaDealStatus.PUBLISHING.toLowerCase(),
    oaDealStatus.READY_FOR_ACTIVATION.toLowerCase(),
    oaDealStatus.ACTIVE.toLowerCase(),
  ];

  return !disabledStatuses.includes(status.toLowerCase());
};
